// extracted by mini-css-extract-plugin
module.exports = {"modal__heading":"deleteModal_modal__heading__2se3c","modal__remainbutton":"deleteModal_modal__remainbutton__3Gb3c","modal__deletebutton":"deleteModal_modal__deletebutton__3EP0s"};